export default class CustNoRequirement {
    constructor() {
        this.dom = {};
        this.$ = null;
        this.init();
    }

    async init() {
        this.$ = await this.loadjQuery();
        
        this.initDomElements();

        if (this.dom.form.length > 0) {
            let self = this;
            this.dom.checkboxSubscription.on('change', function() {
                if (this.checked) {
                    self.setCustnoRequired(true);
                    self.dom.custno.parents('.powermail_fieldwrap').slideDown('fast');
                } else {
                    self.setCustnoRequired(false);
                    self.dom.custno.val('');
                    self.dom.custno.parents('.powermail_fieldwrap').slideUp('fast');
                }
            });

            this.initCustno();
        }
    }

    async loadjQuery() {
        let p = new Promise(function(resolve, reject) {
            window.setTimeout(function() {
                resolve(this.jQuery);
            }, 0);
        });

        return p;
    }

    initDomElements() {
        this.dom.form = this.$('form.powermail_form_5, form.powermail_form_6');
        this.dom.checkboxSubscription = $('#powermail_field_customerstate_1');
        this.dom.custno = this.$('#powermail_field_custno');
        this.dom.custnoLabel = $('.powermail_fieldwrap_custno label');
    }

    initCustno() {
        if (this.dom.custno[0].checked) {
            this.setCustnoRequired(true);
            this.dom.checkboxSubscription.prop('checked', true);
            this.dom.custno.parents('.powermail_fieldwrap').show();
        } else {
            this.setCustnoRequired(false);
        }
    }

    setCustnoRequired(required) {
        if (required) {
            this.dom.custno.attr('required', 'required');
            this.dom.custnoLabel.addClass('mandatory');
            if ($('html')[0].lang.indexOf('de') != -1) {
                this.dom.custno.attr('data-powermail-required-message', 'Dieses Feld muss ausgefüllt werden!');
            } else {
                this.dom.custno.attr('data-powermail-required-message', 'Ce champ doit être rempli !');
            }
        } else {
            this.dom.custno.removeAttr('required');
            this.dom.custnoLabel.removeClass('mandatory');
        }
    }
}